module.exports = __webpack_public_path__ + "static/screenie_drag_video-f0b0964dc158ca719477fdd0b48f4da0.mp4";